<template>
    <div>
        <el-form :inline="true" :model="searchForm"  class="forTbFilter">
           
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" clearable></el-input>
           </el-form-item>
           <el-form-item class="btnArea">
                <el-button type="primary"  @click="getAdminCardListHandler">搜索查询</el-button>
            </el-form-item>
        </el-form>
        <el-table  
        :data="tbpg.tableData"
        :default-sort = "{prop: 'activationrTime', order: 'descending'}"
         border max-height="610" >
            <el-table-column label="ICCID" width="180px">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号" width="130px"></el-table-column>
            <el-table-column prop="totalAmount" label="总通话时长/分钟"></el-table-column>
            <el-table-column prop="useAmount" label="使用通话时长/分钟" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remainAmount" label="剩余通话时长/分钟"  show-overflow-tooltip></el-table-column>
            <el-table-column prop="offeringId" label="套餐id" width="90"></el-table-column>
            <el-table-column prop="offeringName" label="套餐名称" width="90"></el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 

    </div>
</template>

<script>
import {getAdminCardList,getAdminCardList1, exportSimInfo, deleteCard} from '@/api/sim.js'
import {sendSMS} from '@/api/sms.js'
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            searchForm: {
                state:'',
                dataLevel: '',
                totalFlow: '',
                sn: null,
                simPoolId: '',
                supplierId: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  
            flowPoolOption: [],
            supplierOption: [],//运营商名称列表
            agentsOption: [],
            cardStateOption: [],
            simHandleRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'change'}]
            },
            actionFormDataRules:{
                msg:[{required: true, message: '请输入短信内容', trigger: 'blur'}]
            },
            sendSMSVisible: false,//发送短信编辑框
            confirmDialogVisible: false,//删除卡片确认框
            confirmToSendSMSVisible: false,  //短信发送确认框
            actionFormData:{//短信发送等动作携带的数据对象
                receiveIntoNo: '',
                msg:'',
            },
            cardId:'',
                
        }
    },
    methods: {
        
        getAdminCardListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getAdminCardList1(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('detailMenu').click();
        },
    

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAdminCardListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAdminCardListHandler();
        },
        showConfirmToRemoveDialog(row){
            this.cardId = row.id;
            this.confirmDialogVisible = true;
        },
        showSendSMSDialog(row){
            this.actionFormData.receiveIntoNo = row.intoNo;
            this.sendSMSVisible = true;
        },
        hideSendSMSDialog(){
            this.sendSMSVisible = false;    
            this.$refs.actionFormData.resetFields();  
        },
        showConfirmToSendSMSDialog(){
            this.$refs.actionFormData.validate(valid => {
                if(valid){
                    this.confirmToSendSMSVisible = true;
                }
            });
        },
       
       
        formatActivationrTime(row) {
            return row.activationrTime==null ? '' : row.activationrTime.split(' ')[0];
        },    

        formatExpireTime(row) {
            return row.expireTime==null ? '' : row.expireTime.split(' ')[0];
        }, 

       

    },
    created () {
        this.searchForm.state = this.$store.state.menu.cardState;
        this.searchForm.dataLevel = this.$store.state.menu.cardDataLevel;
        this.getAdminCardListHandler();
    
    },

    computed: {
        searchDatefromDataSummary() {
            return {
                cardState:this.$store.state.menu.cardState,
                dataLevel:this.$store.state.menu.cardDataLevel
            }

        },

        
    },

    watch:{
        searchDatefromDataSummary(data){
            this.searchForm.state = data.cardState;
            this.searchForm.dataLevel = data.dataLevel;
            this.getAdminCardListHandler();
            common.getSupplierOptsCom(this, 'supplierOption');
        }
    }
}
</script>

<style lang="scss" scoped>
    .span-defined{
        width: 284px;
        display: inline-block;
        position: relative;
        margin-left: 30px;
    }
    .label-defined{
        display: inline-block;
        height: 32px;
        line-height:32px;
        font-size: 14px;
        color: #606266;
    }
    .percent-label{
        height: 28px;
        line-height: 28px;
        background: #fff;
        z-index: 100;
        position: absolute;
        right: 120px;
        top: 2px;
        font-size: 16px;
    }

    
</style>

